import React from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom';

function FooterContactus() {

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    let contactLinks = [
        {
            linkname: "contact",
            href: "/contact",
        },
    ];

    return (
        <>
            <div className="mt-5">
                <div className="footer_rounded"></div>
                <div className="footer_rounded_bottom">
                    <Container>
                        <Row className="align-items-center py-3 pb-5">
                            <Col md={8} className="mb-md-0 mb-3">
                                <p className="text-white mb-0">Looking for digital solutions that work? Contact OZVA SERVICE for seamless, multi-service support — from web to marketing.</p>
                            </Col>
                            <Col md={4} style={{ justifyItems: 'end' }}>
                                {contactLinks.map((el, i) => {
                                    return (
                                        <div className="d-flex align-items-center gap-2 " key={i}>
                                            <Link className='btn btn-secondary btn-block' style={{ backgroundColor: "#ffffff", borderColor: "#ffffff", color: "#1273eb" }} onClick={scrollToTop} component={Link} to={el.href}>{el.linkname}</Link>
                                            {/* <Link onClick={scrollToTop} to={el.href}>{el.linkname}</Link> */}
                                            {/* {el} */}
                                        </div>
                                    );
                                })}

                                {/* <Button variant="light" className="w-100 py-2 text-primary bg-white fs-5"> Contact Us </Button> */}
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div >
        </>
    )
}

export default FooterContactus